/*Mega Menu Open Close*/
 $(document).ready(function() {
   var timer;
   var delay = 300; // Adjust the delay time as needed

   $('.hd-Banner_NavigationItem').on('mouseenter', function() {
     $(this).addClass("select_menu");
     // Clear any existing timer to prevent rapid toggling
     clearTimeout(timer);

     // Hide all other submenus
     $('.main__navigation').stop(true, true).fadeOut(350);

     // Set a timer to show the associated div after the delay
     timer = setTimeout(() => {
       $(this).find('.main__navigation').stop(true, true).fadeIn(350);
     }, 300);
   });

   $('.hd-Banner_NavigationItem').on('mouseleave', function() {
      $(this).removeClass("select_menu");
     // Clear the timer if the mouse leaves before the delay completes
     clearTimeout(timer);
     // Immediately hide the submenu
      timer = setTimeout(() => {
    $(this).find('.main__navigation').stop(true, true).fadeOut(350);
        }, 350);
   });
});


/* Dropdown Submenu Open Close*/
$(document).ready(function() {
  $('.menuChild_dropdown').on('click', function(e) {
    e.preventDefault(); // Prevent the default action of the anchor tag

    var $submenu = $(this).next('.tps_menuChild_link');

    // Check if the clicked submenu is currently visible
    var isVisible = $submenu.is(':visible');

    // Close all submenus and remove the active class from all menuChild_dropdown elements
    $('.tps_menuChild_link').slideUp(800, 'swing');
    $('.menuChild_dropdown').removeClass('active');

    // If the clicked submenu was not visible, open it and add the active class
    if (!isVisible) {
      $submenu.slideDown(800, 'swing');
      $(this).addClass('active');
    }
  });
});

/* -------------- Menu Selection -------- */ 
function isHomepage() {
    return window.location.pathname === '/'; // Adjust this path if your homepage URL is different
}

// Event listener for visibility change
document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'visible' && isHomepage()) {
        // Remove the localStorage item if on the homepage
      console.log("Yes");
        localStorage.removeItem('activedeskIndex');
        localStorage.removeItem('activeLiItem');
         localStorage.removeItem('activeCollItem');
          localStorage.removeItem('activeGrandchildMenuItem');  
        localStorage.removeItem('activeLiId'); 
        localStorage.removeItem('activeMenuItem');
       $('.hd-Banner_NavigationItems li.hd-Banner_NavigationItem').removeClass('active');
      $('.tps_mega_menu_link li').removeClass('active');
    }
});


/* Desktop Menu Selection */
$(document).ready(function(){
  // Check if there's an active item stored in local storage
  var checkPage = $('#idyTemp').val();
  console.log("checkPage",checkPage);     
  var activedeskIndex = localStorage.getItem('activedeskIndex');

  if (activedeskIndex) {
    // Add the active class to the stored index
    $('.hd-Banner_NavigationItems li.hd-Banner_NavigationItem').eq(activedeskIndex).addClass('active');
  }
  $('.hd-Banner_LogoLink').click(function(){
    localStorage.removeItem('activedeskIndex');
    localStorage.removeItem('activeLiItem');
     localStorage.removeItem('activeCollItem');
    localStorage.removeItem('activeGrandchildMenuItem');  
    localStorage.removeItem('activeLiId'); 
    localStorage.removeItem('activeMenuItem');    
  })
  $('.hd-Banner_NavigationItems li.hd-Banner_NavigationItem').click(function(){

    var targetUrl = $(this).attr('href');
    
    // Remove the 'active' class from all li elements
    $('.hd-Banner_NavigationItems li.hd-Banner_NavigationItem').removeClass('active');
    
    // Add the 'active' class to the clicked li element
    $(this).addClass('active');

    // Store the index of the clicked li element
    var index = $(this).index();
    localStorage.setItem('activedeskIndex', index);     
  });

 

  
  
});



document.addEventListener('DOMContentLoaded', function () {
  var checkPage = $('#idyTemp').val();
  console.log("checkPage",checkPage);

  
  
    const menuDivs = document.querySelectorAll('.coll_megaMenu_inner .tpe_menuCollection_list');
    const liItems = document.querySelectorAll('.tps_inner_megaMenu .tps_mega_menu_link li');

    // Load the stored active div
    const activeDivId = localStorage.getItem('activeCollItem');
    if (activeDivId) {
        const activeDiv = document.querySelector(`.tpe_menuCollection_list[data-id="${activeDivId}"]`);
        if (activeDiv) {
            activeDiv.classList.add('active');
        }
    }

    // Load the stored active li
    const activeLiId = localStorage.getItem('activeLiItem');
    if (activeLiId) {
        const activeLi = document.querySelector(`li[data-id="${activeLiId}"]`);
        if (activeLi) {
            activeLi.classList.add('active');
        }
    }

    // Add click event to each div
    menuDivs.forEach(function (div) {
        div.addEventListener('click', function () {
            // Remove 'active' class from all divs
            menuDivs.forEach(function (div) {
                div.classList.remove('active');
            });

            // Remove 'active' class from all li items
            liItems.forEach(function (li) {
                li.classList.remove('active');
            });

            // Add 'active' class to the clicked div
            this.classList.add('active');

            // Save the active div ID to localStorage
            localStorage.setItem('activeCollItem', this.getAttribute('data-id'));

            // Remove the active li item from localStorage
            localStorage.removeItem('activeLiItem');
        });
    });

    // Add click event to each li
    liItems.forEach(function (li) {
        li.addEventListener('click', function () {
            // Remove 'active' class from all li items
            liItems.forEach(function (li) {
                li.classList.remove('active');
            });

            // Add 'active' class to the clicked li
            this.classList.add('active');

            // Save the active li ID to localStorage
            localStorage.setItem('activeLiItem', this.getAttribute('data-id'));

            // Remove the active div item from localStorage
            localStorage.removeItem('activeCollItem');
        });
    });
  
});


/* Mobile GrandMenu Selection*/ 

document.addEventListener('DOMContentLoaded', function () {
    // Check if the view is mobile
    const isMobileView = window.matchMedia('(max-width: 768px)').matches; // Adjust as needed

    if (!isMobileView) {
        return; // Exit if not in mobile view
    }

    // Function to handle click events
    function handleClick(event) {
        const clickedElement = event.currentTarget;
        const dataId = clickedElement.getAttribute('data-id');
        
        // Remove 'active' class from all items
      $('.drw_custome_care_menu .tps_menuChild_link li').removeClass("active");
       localStorage.removeItem('activeMenuItem');
      
        document.querySelectorAll('.mob_menu_grandsubmenu li').forEach(item => {
            item.classList.remove('active');
        });

        // Add 'active' class to the clicked item
        clickedElement.classList.add('active');

        // Store the active item ID in localStorage
        localStorage.setItem('activeGrandchildMenuItem', dataId);
    }

    // Attach click event listener to .mob_menu_grandsubmenu li
    document.querySelectorAll('.mob_menu_grandsubmenu li').forEach(item => {
        item.addEventListener('click', handleClick);
    });

    // Load the stored active item from localStorage
    const activeItemId = localStorage.getItem('activeGrandchildMenuItem');
    if (activeItemId) {
        const activeItem = document.querySelector(`[data-id="${activeItemId}"]`);
        if (activeItem) {
            activeItem.classList.add('active');
        }
    }
});


document.addEventListener('DOMContentLoaded', function () {
    const isMobileView = window.matchMedia('(max-width: 768px)').matches; // Adjust as needed

    if (!isMobileView) {
        return; // Exit if not in mobile view
    }

    // Function to handle click events on main menu items
    function handleClick(event) {
        const clickedElement = event.currentTarget;
        const dataId = clickedElement.getAttribute('data-id');
        
        // If the clicked element already has 'active' class, do nothing
        if (clickedElement.classList.contains('active')) {
            return;
        }

        // Check if the clicked element has active inner menu items
        const innerMenuItems = clickedElement.querySelectorAll('.mob_mega_submenu .mobile-mega-menu');
        let hasActiveChild = false;

        innerMenuItems.forEach(item => {
            if (item.classList.contains('active')) {
                hasActiveChild = true;
            }
        });

        // If no inner items are active, remove 'active' class from previously active item
        if (!hasActiveChild) {
            document.querySelectorAll('.mobile_mega_menu-Nav_Items .mobile-mega-menu').forEach(item => {
                if (item.classList.contains('active')) {
                    item.classList.remove('active');
                }
            });
        }

        // Add 'active' class to the clicked item
        clickedElement.classList.add('active');

        // Store the active item ID in localStorage
        localStorage.setItem('activeMobileMenuItem', dataId);
    }

    // Attach click event listener to .mobile-mega-menu li
    document.querySelectorAll('.mobile_mega_menu-Nav_Items .mobile-mega-menu').forEach(item => {
        item.addEventListener('click', handleClick);
    });

    // Load the stored active item from localStorage
    const activeItemId = localStorage.getItem('activeMobileMenuItem');
    if (activeItemId) {
        const activeItem = document.querySelector(`.mobile_mega_menu-Nav_Items .mobile-mega-menu[data-id="${activeItemId}"]`);
        if (activeItem) {
            activeItem.classList.add('active');
        }
    }
});


$(document).ready(function () {
    const $menuItems = $('.tps_menuChild_link li');
    const $mobileMegaMenuItems = $('.mobile-mega-menu');
    const $menuGrandchildItems = $('.menu-grandchild-item');
    const $mob_mega_submenu = $('.mob_mega_submenu ');

    // Function to handle click events
    function handleItemClick() {
        const $clickedItem = $(this);

        // Remove 'active' class from all menu items
        $menuItems.removeClass('active');

        // Remove 'active' class from mobile mega menu items
        $mobileMegaMenuItems.removeClass('active');
       localStorage.removeItem("activeMobileMenuItem");

        // Remove 'active' class from menu grandchild items
        $menuGrandchildItems.removeClass('active');
        localStorage.removeItem("activeGrandchildMenuItem");

       // Remove 'active' class from menu grandchild items
        $mob_mega_submenu.removeClass('active');
        localStorage.removeItem("activeLiId");

        // Add 'active' class to the clicked item
        $clickedItem.addClass('active');

        // Save the ID of the active item in localStorage
        localStorage.setItem('activeMenuItem', $clickedItem.data('id') || '');
    }

    // Attach click event listeners to all menu items
    $menuItems.on('click', handleItemClick);

    // On page load, check localStorage for the active item and apply the 'active' class
    const activeItemId = localStorage.getItem('activeMenuItem');
    if (activeItemId) {
        const $activeItem = $(`.tps_menuChild_link li[data-id="${activeItemId}"]`);
        if ($activeItem.length) {
            $activeItem.addClass('active');
        }
    }
});


/* --------Collection----------- */

$(document).ready(function() {
    // Restore the active <li> from localStorage
    let storedId = localStorage.getItem('activeLiId');
    if (storedId !== null) {
        // Remove the 'active' class from all <li> elements within .mob_mega_submenu
        $('.mob_mega_submenu li').removeClass('active');
        // Apply the 'active' class to the <li> with the stored data-id
        $('.mob_mega_submenu li[data-id="' + storedId + '"]').addClass('active');
    }

    // Handle <li> click event
    const $menuGrandchildItems = $('.menu-grandchild-item');
    const $tps_menuChild_link = $('.tps_menuChild_link');
    $('.mob_mega_submenu li').click(function() {
        // Remove the 'active' class from all <li> elements within .mob_mega_submenu
        $('.mob_mega_submenu li').removeClass('active');

        // Add the 'active' class to the clicked <li> element
        $(this).addClass('active');

        // Store the data-id of the clicked <li> in localStorage
        localStorage.setItem('activeLiId', $(this).data('id'));

       event.stopPropagation();

        // Check if the clicked <li> has a <ul> inside its parent <div>
        if ($(this).closest('.menu-container').find('ul').length > 1) {
           
        } else {
            $menuGrandchildItems.removeClass('active');
            localStorage.removeItem("activeGrandchildMenuItem");

           $tps_menuChild_link.removeClass('active');
            localStorage.removeItem("activeMenuItem");
        }
      
    });
});

